<div *ngIf="type === 'text'">
  <div class="l-form-group">
    <label [for]="name" class="form-label l-body" #inputLabel>{{ safeLabel }}</label>
    <input
      type="text"
      [id]="name"
      [placeholder]="placeholder"
      [name]="name"
      #temp="ngModel"
      class="form-input l-form-input"
      [(ngModel)]="value"
    />
    <ng-template [ngTemplateOutlet]="errorMessage"></ng-template>
  </div>
</div>
<div *ngIf="type === 'dropdown'">
  <div class="l-form-group">
    <label [for]="name" class="form-label l-body">{{ safeLabel }}</label>
    <select  class="form-input l-form-input" [id]="name" [name]="name" [(ngModel)]="value">
      <option value="" disabled selected>{{defaultOption ?? 'Country'}}</option>
      <option *ngFor="let option of options" [value]="option.value ?? option.name">{{option.name}}</option>
    </select>
    <ng-template [ngTemplateOutlet]="errorMessage"></ng-template>
  </div>
</div>
<div *ngIf="type === 'password'">
  <div class="l-form-group">
    <label [for]="name" class="form-label l-body">{{ safeLabel }}</label>
    <div class="d-flex align-items-center l-form-input">
      <input
        [type]="showPassword ? 'text' : 'password'"
        [id]="name"
        [placeholder]="placeholder"
        [name]="name"
        #temp="ngModel"
        class="form-input password border-0 w-100"
        [(ngModel)]="value"
      />
      <a class="eye-clickable" (click)="handlePasswordDisplay()">
        <span class="eye-icon">
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use href="../../../../assets/icons/tenantCustomIcons/eye-icon.svg#homeIcon" />
          </svg>
        </span>
      </a>
    </div>
    <div
      class="password-format-error d-flex pb-1"
      *ngIf="
        name === 'password' && control?.errors?.['pattern'] && control?.touched && control?.dirty
      "
    >
      <div class="me-2">
        <img
          class="password-format-error-icon"
          src="../../../../assets/icons/input-error-icon.png"
          alt="password-format-error"
        />
      </div>
      <div class="password-rules">
        <p class="m-0">Must contain atleast 8 characters</p>
        <p class="m-0">Must contain atleast 1 lowercase character</p>
        <p class="m-0">Must contain atleast 1 uppercase character</p>
        <p class="m-0">Must contain atleast 1 numeric character</p>
        <p class="m-0">Must contain atleast 1 special character</p>
      </div>
    </div>
    <ng-template [ngTemplateOutlet]="requiredErrorMessage"></ng-template>
  </div>
</div>
<div *ngIf="type === 'email'">
  <div class="l-form-group">
    <label for="" class="form-label l-body">{{ safeLabel }}</label>
    <input
      type="text"
      [id]="name"
      [placeholder]="placeholder"
      [name]="name"
      #temp="ngModel"
      class="form-input l-form-input"
      [(ngModel)]="value"
      [ngClass]="readOnly && (temp.valid || temp.dirty || temp.touched) ? 'disabledField' : ''"
      [readOnly]="readOnly"
    />
    <ng-template [ngTemplateOutlet]="errorMessage"></ng-template>
  </div>
</div>
<ng-template #errorMessage>
  <span *ngIf="customError" class="l-form-input-error" [innerHTML]="customError | safeHtml">
  </span>
  <span
    *ngIf="control?.errors?.['pattern'] && control?.touched && control?.dirty"
    class="l-form-input-error"
  >
    <img class="me-2" src="../../../../assets/icons/input-error-icon.png" alt="input-error-icon" />
    Invalid {{ safeLabel | lowercase }}
  </span>
  <span
    *ngIf="control?.errors?.['email'] && control?.touched && control?.dirty"
    class="l-form-input-error"
  >
    <img class="me-2" src="../../../../assets/icons/input-error-icon.png" alt="input-error-icon" />
    Enter a valid {{ safeLabel | lowercase }}
  </span>
  <span
    *ngIf="
      control?.errors?.['maxlength'] &&
      !control?.errors?.['pattern'] &&
      (control?.touched || control?.dirty)
    "
    class="l-form-input-error"
  >
    <img class="me-2" src="../../../../assets/icons/input-error-icon.png" alt="input-error-icon" />
    The max limit of {{ control.errors?.['maxlength']?.requiredLength }} characters is reached.
  </span>
  <span
    *ngIf="control?.errors?.['required'] && (control?.dirty || control?.touched)"
    class="l-form-input-error"
  >
    <img class="me-2" src="../../../../assets/icons/input-error-icon.png" alt="input-error-icon" />
    {{ safeLabel }} is required
  </span>
</ng-template>
<ng-template #requiredErrorMessage>
  <span
    *ngIf="control?.errors?.['required'] && (control?.dirty || control?.touched)"
    class="l-form-input-error"
  >
    <img class="me-2" src="../../../../assets/icons/input-error-icon.png" alt="input-error-icon" />
    {{ safeLabel }} is required
  </span>
</ng-template>
